<script lang="ts" setup>
import { NavigationMenuLink } from 'reka-ui';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
</script>

<template>
  <ul class="m-0 flex list-none gap-x-105 px-0 py-32 <lg:flex-col <lg:gap-32 <lg:py-16">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.nav5.children.title1') }}</div>
      <ul class="m-0 w-328 flex flex-col list-none gap-y-16 p-0">
        <li>
          <NavigationMenuLink href="https://community.openatom.cn/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
            {{ $t('header.events.content1.item1.title') }}
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink href="https://xiaoyuanxing.openatom.cn" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
            {{ $t('header.nav5.children.nav1') }}
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink href="https://competition.openatom.tech/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
            {{ $t('header.nav5.children.nav2') }}
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/law" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              {{ $t('header.nav5.children.nav3') }}
            </RouterLink>
          </NavigationMenuLink>
        </li>
        <li v-if="locale === 'zh-CN'">
          <NavigationMenuLink as-child>
            <RouterLink to="/insight/deep-report" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              🔥开源发展深度报告
            </RouterLink>
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/certification" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              {{ $t('header.nav5.children.nav5') }}
            </RouterLink>
          </NavigationMenuLink>
        </li>
        <li v-if="locale === 'zh-CN'">
          <NavigationMenuLink href="https://yuanquxing.openatom.tech/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
            开放原子园区行
          </NavigationMenuLink>
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.nav5.children.title2') }}</div>
      <ul class="m-0 w-328 flex flex-col list-none gap-y-16 p-0">
        <li>
          <NavigationMenuLink as-child>
            <RouterLink to="/events" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline">
              {{ $t('header.nav6.children.nav3') }}
            </RouterLink>
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink href="https://www.bagevent.com/event/openatomcon-2026" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
            {{ $t('header.events.content2.item2.title') }}
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink href="https://openatom.cn/summit/2023/index/main/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
            {{ $t('header.nav6.children.nav1') }}
          </NavigationMenuLink>
        </li>
        <li>
          <NavigationMenuLink href="https://openatom.cn/conference/2026-2/index/main/" class="block h-full text-16 text-#2F2F2F font-500 leading-30 no-underline" target="_blank">
            {{ $t('header.nav6.children.nav2') }}
          </NavigationMenuLink>
        </li>
      </ul>
    </li>
  </ul>
</template>
